<template>
  <div v-if="variant">
    <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
      {{ $t("Available Contracts") }}
    </DialogTitle>
    <Table
      class="mt-5"
      v-if="this.variant.matchedContracts.length > 0"
      :columns="columns"
      :data="variant.matchedContracts"
    >
      <template #price="{ row }">
        <p>{{ formatPrice(row.price, row.currencyCode) }}</p>
      </template>
    </Table>
    <p v-else class="text-center mt-5">{{ $t("No contract available for this variant") }}</p>
  </div>
</template>
<script>
import { Table, formatPrice } from "@estaly/ui";

export default {
  components: { Table },
  props: ["variant"],

  computed: {
    columns() {
      return [
        { label: "Titre", field: "title" },
        { label: "Prix", field: "price", slot: "price" },
      ];
    },
  },

  methods: { formatPrice },
};
</script>
